<template>
  <div class="maindiv index-wrap bg-gray index_main">
    <custome/>
    <div v-if="loading" class="loader cont pt55" style="min-height: 480px" >
      <div class="loader-inner ball-pulse ct">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
    <banner ref="banner" :banners="infos.banner"></banner>
    </div>
    <div class="newsdiv htmldiv mt20">
      <div class="notices wd370 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=1&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-notice img-bg dinline-block vcenter"></span>
              通知公告
            </div>
            <span class="farial tc9 tupper">Notice</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt20">
          <template v-if="infos.notice">
            <div class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5" v-for="(info,index) in infos.notice" v-if="index<8"
                 @click="$router.push(`/evn/detail?id=1&pid=2&article_id=${info.id}&num=${index}`)">
              {{info.title}}
            </div>
          </template>
        </div>
      </div>
<!--      <news v-if="infos.schoolNews" :items="infos.schoolNews" />-->
      <div class="notices wd500 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop ml10">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=0&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-news img-bg dinline-block vcenter"></span>
              校园新闻
            </div>
            <span class="farial tc9 tupper">News</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt20">
          <template v-if="infos.schoolNews">
            <div class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5" v-for="(info,index) in infos.schoolNews" v-if="index<8"
                 @click="$router.push(`/evn/detail?id=0&pid=2&article_id=${info.id}&num=${index}`)">
              {{info.title}}
            </div>
          </template>
        </div>
      </div>

      <div class="ens wd370 ht400 bgw pl15 pr20 pt20 fr br5 vtop">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=2&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-ens img-bg dinline-block vcenter"></span>
              媒体聚焦
            </div>
            <span class="farial tc9 tupper">Admissions</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt20">
          <template v-if="infos.mediaFocus">
            <div v-for="(info,index) in infos.mediaFocus" v-if="index<8"
                 class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5"
                 @click="$router.push(`/evn/detail?id=2&pid=2&article_id=${info.id}&num=${(index+1)}`)">
              {{info.title}}
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="sndiv htmldiv mt20">
      <div class="sns wd370 ht400 bgw pl15 pr10 pt20 dinline-block br5 vtop">
        <div class="st bborder pb5">
          <div class="tab sst dinline-block prelative fs0 cpointer mr20" data-key="1">
            <span class="img-zh img-bg dinline-block vcenter"></span>
            <span class="fs24 vcenter">智慧校园</span>
          </div>
          <div class="tab mr5 dinline-block prelative fs0 cpointer" data-key="2">
            <span class="img-service img-bg dinline-block vcenter"></span>
            <span class="fs24 vcenter">公共服务</span>
          </div>
        </div>
        <div class="cont pt20">
          <div class="scont scont1 pt20">
            <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt10">身份认证</div>
            </a>
            <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt10">OA办公系统</div>
            </a>
            <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt10">后勤服务</div>
            </a>
            <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt10">网络服务</div>
            </a>
            <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt10">图书馆</div>
            </a>
            <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt10">教务系统</div>
            </a>
          </div>
          <div class="scont scont2 dnone">
            <a href="/evn/list?id=5&pid=2" class="sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">人才招聘</div>
            </a>
<!--            <a href="#" class="sdiv sdiv2 dinline-block vtop br5 pt5 mb15">-->
<!--              <div class="igs mat"></div>-->
<!--              <div class="fs15 tcenter mt5">招标公告</div>-->
<!--            </a>-->
            <a href="#" class="tea sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">作息时间</div>
            </a>
            <a href="#" class="open sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">信息公开</div>
            </a>
            <router-link to="/evn/list?id=0&pid=9" class="card sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">教学日历</div>
            </router-link>
            <a href="#" class="receive sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">接待日</div>
            </a>
<!--            <a href="#" class="sdiv sdiv2 dinline-block vtop br5 pt5 mb15">-->
<!--              <div class="igs mat"></div>-->
<!--              <div class="fs15 tcenter mt5">招生信息</div>-->
<!--            </a>-->
<!--            <a href="#" class="sdiv sdiv2 dinline-block vtop br5 pt5 mb15">-->
<!--              <div class="igs mat"></div>-->
<!--              <div class="fs15 tcenter mt5">就业信息</div>-->
<!--            </a>-->
            <a href="#" class="admin sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">院长邮箱</div>
            </a>
            <a href="#" class="video sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">微视频</div>
            </a>
            <a href="#" class="sky sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">航拍 </div>
            </a>
            <a href="#" class="live sdiv sdiv2 dinline-block vtop br5 pt5 mb15">
              <div class="igs mat"></div>
              <div class="fs15 tcenter mt5">直播</div>
            </a>
          </div>
        </div>
      </div>

      <div class="discs wd500 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop ml10 mr10">
        <div class="st bborder pb5">
          <router-link to="/disc" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-dis img-bg dinline-block vcenter"></span>
              专业介绍
            </div>
            <span class="farial tc9 tupper">profession</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt25 pl5">
          <template v-if="infos.professionalIntroduction">
            <disc-item class="sdiv mb30 mb10 dinline-block cpointer br2" v-for="(info,index) in infos.professionalIntroduction" :key="info.id" :item="info">
            </disc-item>
          </template>
        </div>
      </div>

      <div class="zfdiv wd370 ht400 bgw pl15 pr10 pt20 fr br5 vtop">
        <div class="st bborder pb5">
          <div class="tab dinline-block prelative fs0 cpointer mr20" data-key="1">
            <span class="img-zt img-bg dinline-block vcenter"></span>
            <span class="fs24 vcenter">专题专栏</span>
          </div>
          <div class="sst tab mr5 dinline-block prelative fs0 cpointer" data-key="2">
            <span class="img-friend img-bg dinline-block vcenter"></span>
            <span class="fs24 vcenter">友情链接</span>
          </div>
        </div>
        <div class="cont pt20">
          <div class="scont scont1 pt20 dnone">

          </div>
          <div class="scont scont2 pt5">
            <template v-if="infos.links" v-for="(info,index) in infos.links">
              <a target="_blank" :href="info.link" class="dinline-block vtop ofhidden mb15 tran3">
                <img :src="info['picture'][0]" alt="" width="165">
              </a>
            </template>

          </div>
        </div>
      </div>
    </div>

    <div class="env htmldiv bgw pl15 pr20 pt20 pb10 br5 mt20 ht300">
      <div class="st bborder pb5">
        <router-link to="/evn/list?id=7&pid=1" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
        <div class="dinline-block">
          <div class="sst fs24 mr5 dinline-block prelative">
            <span class="img-env img-bg dinline-block vcenter"></span>
            学院风光
          </div>
          <span class="farial tc9 tupper">scenery</span>
        </div>
      </div>
      <div class="cont ofhidden pt30 pl5">
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <nev-item v-else :list="infos.collegeScenery"></nev-item>
      </div>
    </div>
    <div class="ht25"></div>

  </div>
</template>

<script>
import Banner from '@/components/index/Banner'
import News from '@/components/index/News'
import NevItem from "@/components/index/NevItem";
import DiscItem from "@/components/index/DiscItem";
import Custome from "../../components/Custome";
export default {
  name: "index",
  components: {
    Banner,
    News,
    NevItem,
    DiscItem,
    Custome,
  },
  data(){
    return {
      infos:{},
      loading:false
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    $('.sns .tab').mouseover(function() {
      var key = $(this).data('key')
      $(this).addClass('sst').siblings('.tab').removeClass('sst')
      $('.sns .scont' + key).show().siblings('.scont').hide()
    })
  },
  methods:{
    getData(){
      this.loading = true
      this.$request.get('home',[],response => {
        if(response.data.code == 200){
          this.infos = response.data.data
          this.loading = false
        }
        console.log(this.infos)
      },error => {
        console.log(error)
      })
    },
  }
  // beforeRouteEnter(to, form, next) {
  //   this.$refs.banner.initBanner();
  //   next()
  // },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue